module.exports = __webpack_public_path__ + "static/media/teacher.3e7f1646.png";